import Vue from 'vue';
import VueTheMask from 'vue-the-mask';

import PrBox from './PrBox';
import PrDate from './PrDate';
import PrUploadFile from './PrUploadFile';
import PrPagination from './PrPagination';
import PrInputMask from './PrInputMask';
import PrInputMoney from './PrInputMoney';

Vue.component('pr-box', PrBox);
Vue.component('pr-date', PrDate);
Vue.component('pr-upload-file', PrUploadFile);
Vue.component('pr-pagination', PrPagination);
Vue.component('pr-input-mask', PrInputMask);
Vue.component('pr-input-money', PrInputMoney);
Vue.use(VueTheMask);



// WEBPACK FOOTER //
// ./src/components/widgets/index.js